import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from '../../../tms-shared';
import { TmsWebBaseChartService } from '../base';
import { ChartWeeksPurchaseInvoices } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksPurchaseInvoiceService extends TmsWebBaseChartService<ChartWeeksPurchaseInvoices> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService) {
    super('ChartWeeksPurchaseInvoices', httpService);
  }
}
